import { Row } from '@tempmee/react';
import { InviteButton } from '../InviteButton';

// ── inline styles (no DS prop equivalent) ──────────────────────────────────
// marginLeft/marginRight have no DS Box prop
const actionsRowStyle = { marginLeft: 24, marginRight: 32 };

export const ProfessionalCardActions = ({ user }) => (
  <Row direction="row" justify="center" align="center" gap={5} style={actionsRowStyle}>
    <InviteButton
      user={{
        id: user?.id,
        image: user?.profileImage,
        name: user?.fullname,
        profession: user?.professions?.join(','),
        professions: user?.professions,
        isFavorite: true,
      }}
      disabled={!user?.isAvailable}
      source="favorites"
    />
  </Row>
);
